import React from 'react';
import PrivateRoute from './PrivateRoute';
import { getPathApp } from '../utils/util';
import Home from '../containers/Home/Home';
import ListNotifications from '../containers/General/Notification/ListNotifications';
import Notification from '../containers/General/Notification/Notification';

let aux = 0;
const pathurl = getPathApp(window);
const GlobalRoute = [
    <PrivateRoute key={aux += 1} exact path={`${pathurl}/listNotifications`} component={ListNotifications} />,
    <PrivateRoute key={aux += 1} exact path={`${pathurl}/notification/:id`} component={Notification} />,
    <PrivateRoute key={aux += 1} exact path={`${pathurl}/packlist/confirm`} component={ListNotifications} />,

    <PrivateRoute key={aux += 1} path={`${pathurl}/home`} component={Home} />,
    <PrivateRoute key={aux += 1} exact path={`${pathurl}/`} component={Home} />
];

export default GlobalRoute;
